export default "__VITE_ASSET__C2CdU4mM__"